import { render, staticRenderFns } from "./userRoleStatus.vue?vue&type=template&id=3412c0a0&"
import script from "./userRoleStatus.vue?vue&type=script&lang=js&"
export * from "./userRoleStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports